export const fetchCustomers = async () => {
  const subdomain = window.location.hostname.split('.')[0];
  const apiUrl = `https://${subdomain}.restocash.app/api/customers?api_password=Project102$_`;

  const token = localStorage.getItem("token");

  try {
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    });

    const data = await response.json();

    if (!response.ok) {
      console.error("❌ Error fetching customers:", data);
      throw new Error(data?.message || "Failed to fetch customers");
    }

    console.log("✅ Customers data:", data.data);
    return data.data; // فقط مصفوفة العملاء
  } catch (error) {
    console.error("❌ Exception while fetching customers:", error);
    throw error;
  }
};
